import { 
    SET_SITE_CONFIG
} from "./mutations.type";

export const config = {
    namespaced: true,
    state: {
        siteConfig: {
            "domainName": "app.getinsync.ca",
            "apiDomainName": "api.getinsync.ca",
            "siteTitle": "GetInSync Platform",
            "logoFilename": "logo.png",
            "darkLogoFilename": "dark-logo.png",
            "miniLogoFilename": "icon.png",
            "favicon32Filename": "favicon-32x32-prod.png",
            "favicon16Filename": "favicon-16x16-prod.png",
            "poweredBy": false
        }
    },
    getters: {
        apiUrl: state => {
            return `https://${state.siteConfig.apiDomainName}/api`;
        },
        apiBaseUrl: state => {
            return `https://${state.siteConfig.apiDomainName}`;
        },
        domainUrl: state => {
            return `https://${state.siteConfig.domainName}`;
        },
        siteTitle: state => {
            return state.siteConfig.siteTitle;
        },
        siteLogoUrl: state => {
            return `https://${state.siteConfig.apiDomainName}/SiteLogos/${state.siteConfig.logoFilename}`;
        },
        siteDarkLogoUrl: state => {
            return `https://${state.siteConfig.apiDomainName}/SiteLogos/${state.siteConfig.darkLogoFilename}`;
        },
        siteMiniLogoUrl: state => {
            return `https://${state.siteConfig.apiDomainName}/SiteLogos/${state.siteConfig.miniLogoFilename}`;
        },
        siteFavicon32Url: state => {
            return `https://${state.siteConfig.apiDomainName}/SiteLogos/${state.siteConfig.favicon32Filename}`;
        },
        siteFavicon16Url: state => {
            return `https://${state.siteConfig.apiDomainName}/SiteLogos/${state.siteConfig.favicon16Filename}`;
        },
        showPoweredBy: state => {
            return state.siteConfig.poweredBy;
        }
    },
    actions: {
    },
    mutations: {
        [SET_SITE_CONFIG](state, value) {
            state.siteConfig = value;
        },
    }
}
